export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./scratchWorksPlay.vue?vue&type=template&id=32f88785&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/scratchWorksPlay/scratchWorksPlay.vue?vue&type=template&id=32f88785&scoped=true&
// module id = null
// module chunks = 